import React from 'react'
import styled from 'styled-components/macro'
import {
  Button, Text, Spacer
} from 'components/atoms'
import { useToggle } from 'hooks'
import { PageCreateLanguageModal } from 'containers'
import { useParams } from 'react-router-dom'

const EditorNoContent = () => {
  const [isOpen, toggle] = useToggle(false)
  const { lang } = useParams()

  return (
    <Wrapper>
      <PageCreateLanguageModal
        isOpen={isOpen}
        toggle={toggle}
        newLanguage={lang}
      />
      <Spacer bottom="xl">
        <Text>
          Página indisponível na língua seleccionada, crie a versão da página para poder editar:
        </Text>
      </Spacer>
      <Button modifiers={['dark']} icon="fal fa-plus-square" onClick={toggle}>
        Criar página na nova língua
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: ${props => props.theme.spacing.xl6} 0;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`

export default EditorNoContent
